import threeDots from '../../assets/threeDots.png';

export const ThreeDotsIcon = () => {
  return (
    <div className='w-[12px]'>
      <img src={threeDots} className='min-w-[12px]' />
    </div>
  );
};
